import { createSlice } from "@reduxjs/toolkit";
import {
  getSuperbillFlow,
  createSuperbillFlow,
  updateSuperbillFlow,
  deleteSuperbillFlow,
  clearLocalActiveSuperbillFlow
} from './actions';

const initialState = {
  superbillFlow: { 
    id: '', 
    before_in: '',
    start_at: '', 
    time_zone: '',
    prompt: '',
    clinician_email: '',
    superbill_email: '',
    updated_at: '' 
  },
  loading: false
};

const slice = createSlice({
  name: 'superbillFlows',
  initialState,
  extraReducers(builder) {
    builder
      .addCase(getSuperbillFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSuperbillFlow.fulfilled, (state, action) => {
        const { superbill_flow } = action.payload;
        const superbillFlow = { ...state.superbillFlow, ...superbill_flow };
        
        state.loading = false;
        state.superbillFlow = superbillFlow;
      })
      .addCase(getSuperbillFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(createSuperbillFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(createSuperbillFlow.fulfilled, (state, action) => {
        const { superbill_flow } = action.payload;
        
        state.loading = false;
        state.superbillFlow = superbill_flow;       
      })
      .addCase(createSuperbillFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(updateSuperbillFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateSuperbillFlow.fulfilled, (state, action) => {
        const { status, superbill_flow } = action.payload;
        const updatedSuperbillFlow = { ...state.superbillFlow, ...superbill_flow };
        
        state.loading = false;
        if (status === 204) state.superbillFlow = updatedSuperbillFlow;       
      })
      .addCase(updateSuperbillFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(deleteSuperbillFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteSuperbillFlow.fulfilled, (state, action) => {
        const { status } = action.payload;
        
        state.loading = false;
        if (status === 204) state.superbillFlow = initialState.superbillFlow;       
      })
      .addCase(deleteSuperbillFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(clearLocalActiveSuperbillFlow, state => {
        state.superbillFlow = initialState.superbillFlow;
      })
  }
})

export default slice.reducer;